import { render, staticRenderFns } from "./feeback.vue?vue&type=template&id=4b723366&scoped=true&"
import script from "./feeback.vue?vue&type=script&lang=js&"
export * from "./feeback.vue?vue&type=script&lang=js&"
import style0 from "./feeback.vue?vue&type=style&index=0&id=4b723366&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b723366",
  null
  
)

export default component.exports